import React, { useContext, useEffect, useState } from "react";
//import { Room, Rate } from '../../../backend/src/models/hotelAvailabilty';
//import { PropertyRoom } from "../../../backend/src/models/getPropertyAvailability";
import { Rate } from "../../../backend/src/models/rateHawkModels/hotelPageResponseModel";

type HotelContextType = {
    roomCode: string;
    roomName: string;
    hotelName: string;
    roomType: string;
    roomPrice: string;
    //roomRateKey: string;
    hotelId: string;
    grossPrice: string;
    cancellationPenalties: any;
    includedBySupplier: any;
    matchRoom: string;
    selectedRoom: Rate | null;
    //selectedDeal: Deal | null;
    saveHotelValues: (
        roomCode: string,
        roomName: string,
        hotelName: string,
        roomType: string,
        roomPrice: string,
        //roomRateKey: string,
        hotelId: string,
        grossPrice: string,
        cancellationPenalties: any,
        includedBySupplier: any,
        matchRoom: string,
    ) => void;
    saveRoomAndRate: (room: Rate | null) => void;
    bookingFormResponse: any;
    saveBookingFormResponse: (response: any) => void;
};

const HotelContext = React.createContext<HotelContextType | undefined>(undefined);

type HotelContextProviderProps = {
  children: React.ReactNode;
};

export const HotelContextProvider = ({ children }: HotelContextProviderProps) => {
    useEffect(() => {
        const storedRoomCode = sessionStorage.getItem("roomCode");
        //const storedRoomRateKey = sessionStorage.getItem("roomRateKey");
      
        // console.log("Loaded roomCode from sessionStorage: ", storedRoomCode);
        // console.log("Loaded roomRateKey from sessionStorage: ", storedRoomRateKey);
      
        if (storedRoomCode) setRoomCode(storedRoomCode);
        //if (storedRoomRateKey) setRoomRateKey(storedRoomRateKey);
    }, []);

    const [roomCode, setRoomCode] = useState<string>(
        () => sessionStorage.getItem("roomCode") || ""
    );

    const [roomName, setRoomName] = useState<string>(
        () => sessionStorage.getItem("roomName") || ""
    );

    const [hotelName, setHotelName] = useState<string>(
        () => sessionStorage.getItem("hotelName") || ""
    )

    const [roomType, setRoomType] = useState<string>(
        () => sessionStorage.getItem("roomType") || ""
    )

    const [roomPrice, setRoomPrice] = useState<string>(
        () => sessionStorage.getItem("roomPrice") || ""
    )

    // const [roomRateKey, setRoomRateKey] = useState<string>(
    //     () => sessionStorage.getItem("roomRateKey") || ""
    // )

    const [hotelId, setHotelId] = useState<string>(
        () => sessionStorage.getItem("hotelId") || ""
    )

    const [grossPrice, setGrossPrice] = useState<string>(
        () => sessionStorage.getItem("grossPrice") || ""
    )

    const [cancellationPenalties, setCancellationPenalties] = useState<any>(
        () => sessionStorage.getItem("cancellationPenalties") || ""
    )

    const [includedBySupplier, setIncludedBySupplier] = useState<any>(
        () => sessionStorage.getItem("includedBySupplier") || ""
    );

    const [matchRoom, setMatchRoom] = useState<string>(
        () => sessionStorage.getItem("matchRoom") || ""
    )

    const [selectedRoom, setSelectedRoom] = useState<Rate | null>(
        () => {
            const storedRoom = sessionStorage.getItem("selectedRoom");
            return storedRoom ? JSON.parse(storedRoom) : null;
        }
    );
    // const [selectedDeal, setSelectedDeal] = useState<Deal | null>(
    //     () => {
    //         const storedRate = sessionStorage.getItem("selectedDeal");
    //         return storedRate ? JSON.parse(storedRate) : null;
    //     }
    // );
    


    const saveHotelValues = (
        roomCode: string,
        roomName: string,
        hotelName: string,
        roomType: string,
        roomPrice: string,
        //roomRateKey: string,
        hotelId: string,
        grossPrice: string,
        cancellationPenalties: any,
        includedBySupplier: any,
        matchRoom: string,
    ) => {
        // console.log('Saving Hotellll values: ', {
        //     roomCode,
        //     roomName,
        //     hotelName,
        //     roomType,
        //     roomPrice,
        //     roomRateKey,
        //     hotelId,
        //     grossPrice,
        //     discountPrice,

        // });
        setRoomCode(roomCode);
        setRoomName(roomName);
        setHotelName(hotelName);
        setRoomType(roomType);
        setRoomPrice(roomPrice);
        //setRoomRateKey(roomRateKey);
        setHotelId(hotelId);
        setGrossPrice(grossPrice);
        setCancellationPenalties(cancellationPenalties);
        setIncludedBySupplier(includedBySupplier);
        setMatchRoom(matchRoom);

        sessionStorage.setItem("roomCode", roomCode);
        sessionStorage.setItem("roomName", roomName);
        sessionStorage.setItem("hotelName", hotelName);
        sessionStorage.setItem("roomType", roomType);
        sessionStorage.setItem("roomPrice", roomPrice);
        //sessionStorage.setItem("roomRateKey", roomRateKey);
        sessionStorage.setItem("hotelId", hotelId);
        sessionStorage.setItem("grossPrice", grossPrice);
        sessionStorage.setItem("cancellationPenalties", JSON.stringify(cancellationPenalties));
        sessionStorage.setItem("includedBySupplier", includedBySupplier.toString());
        sessionStorage.setItem("matchRoom", matchRoom);
    };

    const saveRoomAndRate = (room: Rate | null) => {
        // console.log("Saving selected room and rate:", { room, deal });
        setSelectedRoom(room);
        //setSelectedDeal(deal);

        if (room) {
            sessionStorage.setItem("selectedRoom", JSON.stringify(room));
            //sessionStorage.setItem("selectedDeal", JSON.stringify(deal));
        } else {
            sessionStorage.removeItem("selectedRoom"); // Clear the stored values
            //sessionStorage.removeItem("selectedDeal");
        }
    };

    const [bookingFormResponse, setBookingFormResponse] = useState<any>(null);

    const saveBookingFormResponse = (response: any) => {
    setBookingFormResponse(response);
    };

    return(
        <HotelContext.Provider
            value={{
                roomCode,
                roomName,
                hotelName,
                roomType,
                roomPrice,
                //roomRateKey,
                hotelId,
                grossPrice,
                cancellationPenalties,
                includedBySupplier,
                matchRoom,
                selectedRoom,
                //selectedDeal,
                saveHotelValues,
                saveRoomAndRate,
                bookingFormResponse,
                saveBookingFormResponse,
            }}
        >
            {children}
        </HotelContext.Provider>
    );
};

export const useHotelContext = () => {
    const context = useContext(HotelContext);
    if (context === undefined) {
        throw new Error("useSearchContext must be used within a SearchContextProvider");
    }
    return context;
}